import { Typography } from '@frontend/design_system'
import { InfoBlockProps } from './types'
import { CURRENCY_SYMBOL } from 'constants/currencies'
import { WidgetItem } from './components/WidgetItem'
import { INFO_BLOCK } from 'texts/dashboard'
import { formatNumberWithKilo } from 'utils/formatters'
import styles from './styles.module.scss'

export const InfoBlock = ({
  volumesData,
  revenueData,
  currency,
}: InfoBlockProps) => (
  <div
    className={styles['info-block-wrapper']}
    data-testid="info-block-wrapper"
  >
    <div className={styles.volumes}>
      <div>
        <Typography name="h6WSemibold" Tag="p">
          {INFO_BLOCK.VOLUMES.TITLE}
        </Typography>
        <Typography name="body2WRegular" color="grey500">
          {INFO_BLOCK.VOLUMES.SUBTITLE}
        </Typography>
      </div>
      <div className={styles['volumes-widget']}>
        <WidgetItem
          counter={formatNumberWithKilo(volumesData?.reservations || 0)}
          percent={volumesData?.reservationsPercentVsPrevious}
          counterLabel={INFO_BLOCK.VOLUMES.RESERVATIONS}
          dataTestId="reservations-widget"
        />
        <WidgetItem
          counter={formatNumberWithKilo(volumesData?.rentalDays || 0)}
          percent={volumesData?.rentalDaysPercentVsPrevious}
          counterLabel={INFO_BLOCK.VOLUMES.RENTAL_DAYS}
          dataTestId="rental-days-widget"
        />
      </div>
    </div>
    <div className={styles.revenue}>
      <Typography name="h6WSemibold" Tag="p">
        {INFO_BLOCK.REVENUE.TITLE}
      </Typography>
      <Typography name="body2WRegular" color="grey500">
        {`${currency || ''}${INFO_BLOCK.REVENUE.SUBTITLE}`}
      </Typography>
      <div className={styles['revenue-widget']}>
        <WidgetItem
          counter={`${formatNumberWithKilo(revenueData?.revenue || 0)}<mark>${
            currency && CURRENCY_SYMBOL[currency]
              ? CURRENCY_SYMBOL[currency]
              : ''
          }</mark>`}
          percent={revenueData?.revenuePercentVsPrevious || 0}
          dataTestId="revenue-widget"
        />
      </div>
    </div>
  </div>
)
